module.exports = __webpack_public_path__ + "img/app-bottom-menu.032cc750.png";